import { type FC, type ReactNode } from "react"

interface EmptyPageProps {
  children?: ReactNode
}

export const EmptyPage: FC<EmptyPageProps> = ({ children }) => {
  return (
    <div
      className="flex h-screen w-full items-center justify-center flex-col overflow-hidden bg-background"
      data-testid="empty-page"
    >
      {children}
    </div>
  )
}
